import PropTypes from 'prop-types';
import {isSrc, isColor} from '../utils/PropUtils';

const externalSrc = (props: any, propName: string, componentName: string): Error | null => {
    if (!isSrc(props[propName])) {
        return new Error(
            `Invalid prop ${propName} supplied to ${componentName}. Validation failed.`
        );
    }

    return null;
};

const color = (props: any, propName: string, componentName: string): Error | null => {
    if (props[propName] && !isColor(props[propName])) {
        console.log('color', props[propName]);
        return new Error(
            `Invalid prop ${propName} supplied to ${componentName}. Validation failed.`
        );
    }

    return null;
};

const icon = PropTypes.oneOfType([
    externalSrc,
    PropTypes.shape({
        viewBox: PropTypes.string,
        data: PropTypes.node
    })
]);

export default {
    externalSrc,
    color,
    icon
};
